"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral")),
    _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\nquery getAddonsByType {\n  getAddonsByType {\n    BURN_IN_CAPTIONS {\n      costs\n    }\n    SRT_CAPTIONS {\n      costs\n    }\n    LONGFORM_SHORT {\n      costs\n    }\n    CHROMA_KEY {\n      costs\n    }\n    EXTRA_FOOTAGE {\n      costs\n    }\n    RUSH_EDIT {\n      costs\n    }\n    SUPER_RUSH_EDIT {\n      costs\n    }\n    LONGFORM_MEDIUM {\n      costs\n    }\n    LONGFORM_LONG {\n      costs\n    }\n    VIDEO_OUTPUT {\n      costs\n    }\n  }\n}\n"]);
  return _templateObject = function _templateObject() {
    return data;
  }, data;
}

var getAddonsByTypeQuery = (0, _graphqlTag["default"])(_templateObject()),
    getAddonsByType = function getAddonsByType() {
  return {
    query: getAddonsByTypeQuery,
    module: "finance",
    ignoreCache: !0,
    buildVariables: function buildVariables() {}
  };
},
    _default = getAddonsByType;

exports["default"] = _default;